import { toast } from "react-toastify";
import { takeLatest, call, put } from "redux-saga/effects";
import {
  addBookingToCreditCardAction,
  addCreditCardAction,
  creditCardDetailAction,
  deleteCreditCardAction,
  getAllCreditCardsAction,
  updateCreditCardAction,
} from "../api/creditcard-action";
import {
  getAllCreditCards,
  getCreditCardDetail,
  setCreditCardDetailLoading,
  setCreditCardLoading,
  setTransactionRecordStoreStatustrue,
} from "../redux/app/creditcard/creditcard-slice";

export function* createCardSaga(action) {
  try {
    const response = yield call(addCreditCardAction, action.payload);
    if (response.status === 200) {
      toast.success("Credit Card Added Successfully");
      yield put({
        type: "GET_ALL_CREDIT_CARDS",
        payload: {
          token: action.payload.token,
        },
      });
    }
  } catch (error) {}
}

export function* getAllCardsSaga(action) {
  try {
    yield put(
      setCreditCardLoading({
        creditcardLoading: true,
      })
    );
    const response = yield call(getAllCreditCardsAction, action.payload);
    if (response.status === 200) {
      yield put(
        setCreditCardLoading({
          creditcardLoading: false,
        })
      );
      yield put(
        getAllCreditCards({
          allCreditCards: response?.data?.creditCards,
        })
      );
    }
  } catch (error) {}
}

export function* updateCardSaga(action) {
  try {
    const response = yield call(updateCreditCardAction, action.payload);
    if (response.status === 200) {
      toast.success("Credit Card Updated Successfully");
      yield put({
        type: "GET_ALL_CREDIT_CARDS",
        payload: action.payload,
      });
    }
  } catch (error) {}
}

export function* deleteCardSaga(action) {
  try {
    const response = yield call(deleteCreditCardAction, action.payload);

    if (response.status === 200) {
      toast.success("Credit Card Deleted Successfully");
      yield put({
        type: "GET_ALL_CREDIT_CARDS",
        payload: action.payload,
      });
    }
  } catch (error) {}
}

export function* addBookingToCreditCardSaga(action) {
  try {
    const response = yield call(addBookingToCreditCardAction, action.payload);
    if (response.status === 200) {
      yield put(
        setTransactionRecordStoreStatustrue({
          txnId: action.payload.txnId,
        })
      );
    }
  } catch (error) {}
}

export function* creditCardDetailSaga(action) {
  try {
    yield put(setCreditCardDetailLoading({ creditCardDetailLoading: true }));
    const response = yield call(creditCardDetailAction, action.payload);

    if (response.status === 200) {
      yield put(setCreditCardDetailLoading({ creditCardDetailLoading: false }));
      yield put(
        getCreditCardDetail({
          creditCardDetail: response?.data,
        })
      );
    }
  } catch (error) {}
}

export function* watchCreditCardAsync() {
  yield takeLatest("ADD_CREDIT_CARD", createCardSaga);
  yield takeLatest("GET_ALL_CREDIT_CARDS", getAllCardsSaga);
  yield takeLatest("UPDATE_CREDIT_CARD", updateCardSaga);
  yield takeLatest("DELETE_CREDIT_CARD", deleteCardSaga);
  yield takeLatest("ADD_BOOKING_TO_CREDIT_CARD", addBookingToCreditCardSaga);
  yield takeLatest("GET_CREDIT_CARD_DETAIL", creditCardDetailSaga);
}
